import { render, staticRenderFns } from "./wjTaskManageList.vue?vue&type=template&id=e362115e&"
import script from "./wjTaskManageList.vue?vue&type=script&lang=js&"
export * from "./wjTaskManageList.vue?vue&type=script&lang=js&"
import style0 from "./wjTaskManageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports